export default __webpack_public_path__ + "static/media/tele.8e3dfec3.svg";